export default "https://cdn-static.gokick.com/assets/392c20f622263512bf2611e9ba1d645afacce893/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";